import { z } from 'zod';

export const CouponZod = z.object({
    id: z.string(),
    name: z.string(),
    percentOff: z.number(),
    valid: z.boolean(),
    duration: z.string(),
});
export type Coupon = z.infer<typeof CouponZod>;
